import { jsx as _jsx } from "react/jsx-runtime";
import { Argon } from '../argon';
export const Neon = ({ documentTitle, title, tabs, sider, progress, content, actions: { primary, secondary, central }, isDistractionFree, siderResizable, siderWidth, siderOffset, siderMinWidth, siderMaxWidth, onResize, onResizeStart, onResizeStop, $island })=>{
    return /*#__PURE__*/ _jsx(Argon, {
        isDistractionFree: isDistractionFree,
        documentTitle: documentTitle,
        title: title,
        tabs: tabs,
        sider: sider,
        progress: progress,
        content: content,
        siderResizable: siderResizable,
        siderMinWidth: siderMinWidth,
        siderMaxWidth: siderMaxWidth,
        siderOffset: siderOffset,
        siderWidth: siderWidth,
        actions: {
            primary,
            secondary,
            central
        },
        onResize: onResize,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        $island: $island
    });
};
